// src/components/marketing/ContentBlock.jsx
import React from "react";

const ContentBlock = ({ title = "", children, highlight = false }) => {
  if (highlight) {
    return (
      <section className="relative left-1/2 right-1/2 w-screen -translate-x-1/2 bg-white py-20 px-5 my-20">
        <div className="mx-auto max-w-3xl">
          {title && typeof title === "string" && (
            <h2 className="font-['Lexend_Deca'] text-charcoal-800 text-3xl md:text-4xl leading-tight mt-0 mb-6">
              {String(title)}
            </h2>
          )}
          <div className="text-charcoal-800 leading-8 text-lg">{children}</div>
        </div>
      </section>
    );
  }

  return (
    <section className="mb-20">
      {title && typeof title === "string" && (
        <h2 className="font-['Lexend_Deca'] text-charcoal-800 text-3xl leading-tight mt-0 mb-5">
          {String(title)}
        </h2>
      )}
      <div className="text-charcoal-800 leading-8 text-lg">{children}</div>
    </section>
  );
};

export default ContentBlock;
